import React, { useEffect } from "react";
import { Row, Col, Slider } from "antd";
import axios from "axios";
import { useForm } from "react-hook-form";
import { ColorSlider } from "./sliders/color-slider/ColorSlider";
import { OrderButton } from "./buttons/OrderButton";
import CustomizationDropZone from "./CustomizationDropZone";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

export type IColorsFormProps = {
  setActiveTabKey: (s: string) => void;
  handleChange: any;
  attachFile: any;
  deleteFile: any;
  globalData: any;
  handleColorImg: any;
  isDenim: boolean;
};

const ColorsForm: React.FC<IColorsFormProps> = ({
  setActiveTabKey,
  handleChange,
  attachFile,
  deleteFile,
  globalData,
  handleColorImg,
  isDenim,
}) => {
  const [colours, setColours] = React.useState<any>(null);
  const [marks, setMarks] = React.useState<any>({});
  const [valueColour, setValueColour] = React.useState(50);
  const { register, control, handleSubmit, watch, errors } = useForm();
  const [colorSliderValue, setColorSliderValue] = React.useState(50);
  const { selectedProduct } = useSelector((state: any) => state.products);
  const params = useParams<any>();

  const onSubmit = (data: any) => {
    const submitData = { ...data, colorValue: colorSliderValue };
    setActiveTabKey("4");
  };

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          "/colors/" +
          (params.status === "edit"
            ? selectedProduct.original_product.color_id
            : selectedProduct.color_id)
      )
      .then((response: any) => setColours(response.data))
      .catch((err) => console.log(err.response));
  }, []);

  useEffect(() => {
    if (colours) {
      let mark = Math.round(100 / (colours.length - 1));
      let x: any = {};
      for (let i in colours) {
        x[mark * Number(i)] = colours[i] && colours[i].name;
      }
      setMarks(x);
    }
  }, [colours]);
  //fabric_type
  const [color, setColor] = React.useState("");
  useEffect(() => {
    if (color) {
      handleColorImg(color);
    }
  }, [color]);

  const [fabricImage, setfabricName] = React.useState("");

  /*   useEffect(() => {
    setfabricName(globalData.fabric);
    
  }, [color]); */

  /*   console.log(fabricName); */
  useEffect(() => {
    let token = localStorage.getItem("token");
    axios
      .get(
        process.env.REACT_APP_API_URL +
          "/clients/customization/fabricname/" +
          globalData.fabric,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setfabricName(res.data);
      });
  }, []);
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* <Row>
     <Col span={24}>
      <div className="slider-fabric-img text-center mb-3">
       <img
        src={
         colours &&
         colours.find((el: any) => el.name === marks[valueColour]) &&
         process.env.REACT_APP_STORAGE_URL +
          colours.find((el: any) => el.name === marks[valueColour]).image
        }
        alt=""
        style={{ borderRadius: "50%", width: 60 }}
       />
      </div>
     </Col>
    </Row> */}
        <Row>
          <Col span={24}>
            {isDenim ? (
              <ColorSlider
                returColorValue={(value) => setColorSliderValue(value)}
                color_img={colours}
                handleColorImg={handleColorImg}
                fabricImage={fabricImage}
              />
            ) : (
              <input
                className="style_input"
                type="text"
                placeholder="Enter pantone code"
                name="pantone_code_knit"
                // value={color}
                onChange={(e: any) => setColor(e.target.value)}
                // ref={register({ required: true })}
                value={globalData.color}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <textarea
              placeholder="More Details"
              className="textarea-custom"
              rows={3}
              name="color_details"
              onChange={(e: any) => handleChange(e)}
              // ref={register({ required: true })}
              value={globalData.color_details}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CustomizationDropZone
              attachFile={attachFile}
              detachFile={deleteFile}
              files={globalData.color_files}
              objectKey={"color_files"}
            />
          </Col>
        </Row>
        {/* <div style={{ alignSelf: "flex-end", marginTop: "auto" }}>
          <OrderButton title="Next" />
        </div> */}
      </div>
    </form>
  );
};

export { ColorsForm };
